import React, { useState } from "react";
import { Box, TextField, Button, InputAdornment, Typography } from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import ChatBubbleIcon from '@mui/icons-material/ChatBubble';
import SendIcon from '@mui/icons-material/Send';
import gitImage from "../../assets/images/1fZK.gif";

function Contact() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setTimeout(() => {
            setIsSubmitting(false);
            setFormData({ name: "", email: "", message: "" });
        }, 2000);
    };

    return (
        <Box className="contact-section" id="contact" sx={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: 'transparent' }}>
            <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', gap: { xs: 4, md: 8 } }}>
                {/* Branding Section */}
                <Box className="contact-description" sx={{ flex: 1, textAlign: 'center', mb: { xs: 4, md: 0 }, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className="personal-branding fade-in">
                        <div className="name-tag">
                            &lt;<span className="font-carattere">Mohit Lamba</span>/&gt;
                        </div>
                        <div className="personal-quote">
                            "Consistency and creativity – the two engines that power every elegant solution I build."
                        </div>
                        <Box className="avatar-container" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: 3 }}>
                            <img
                                src={gitImage}
                                className="avatar-image"
                                alt="Mohit Lamba"
                                loading="lazy"
                                style={{
                                    width: 200,
                                    height: 200,
                                    objectFit: 'cover',
                                    borderRadius: 16,
                                    boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
                                    border: '2px solid #64ffda',
                                    background: '#222',
                                    margin: '0 auto',
                                    maxWidth: '100%',
                                    maxHeight: 200,
                                }}
                            />
                        </Box>
                    </div>
                </Box>
                {/* Contact Form Section */}
                <Box className="contact-form-container fade-in" sx={{ flex: 1, minWidth: { md: 450 }, display: 'flex', justifyContent: 'center', maxWidth: { xs: '100%', md: 600 } }}>
                    <Box component="form" onSubmit={handleSubmit} className="contact-form-mui" sx={{
                        width: '100%',
                        maxWidth: 450,
                        minWidth: { md: 350 },
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        alignItems: 'center',
                        bgcolor: 'rgba(45,45,45,0.8)',
                        p: { xs: 2, sm: 4 },
                        borderRadius: 3,
                        boxShadow: 3,
                        '@media (max-width: 600px)': {
                            maxWidth: '100%',
                            minWidth: 0,
                            p: 1,
                            gap: 2,
                        }
                    }}>
                        <Typography variant="h4" align="center" sx={{ mb: 1, color: '#64ffda', fontWeight: 700 }}>
                            Get In Touch <SendIcon sx={{ fontSize: 32, color: '#00d4ff', ml: 1, verticalAlign: 'middle' }} />
                        </Typography>
                        <Typography variant="subtitle1" align="center" sx={{ mb: 2, color: '#b0b0b0' }}>
                            Let's discuss your next project or just say hello!
                        </Typography>
                        <Typography variant="body2" align="center" sx={{ mb: 2, color: '#888888', fontSize: '0.9rem' }}>
                            <i className="fas fa-phone" style={{ marginRight: '8px' }}></i>
                            +91 8979091615
                        </Typography>
                        <Typography variant="body2" align="center" sx={{ mb: 2, color: '#888888', fontSize: '0.9rem' }}>
                            <i className="fas fa-map-marker-alt" style={{ marginRight: '8px' }}></i>
                            Bangalore, India
                        </Typography>
                        {/* Name Field */}
                        <TextField
                            id="name"
                            name="name"
                            label="Name"
                            variant="outlined"
                            fullWidth
                            required
                            value={formData.name}
                            onChange={handleInputChange}
                            placeholder="Your name"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <PersonIcon sx={{ color: '#64ffda', fontSize: 28 }} />
                                    </InputAdornment>
                                ),
                                sx: { fontSize: '1.2rem' }
                            }}
                            inputProps={{ style: { fontSize: '1.2rem' } }}
                            sx={{ bgcolor: 'rgba(255,255,255,0.05)', borderRadius: 2 }}
                        />
                        {/* Email Field */}
                        <TextField
                            id="email"
                            name="email"
                            label="Email"
                            type="email"
                            variant="outlined"
                            fullWidth
                            required
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Your email"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EmailIcon sx={{ color: '#64ffda', fontSize: 28 }} />
                                    </InputAdornment>
                                ),
                                sx: { fontSize: '1.2rem' }
                            }}
                            inputProps={{ style: { fontSize: '1.2rem' } }}
                            sx={{ bgcolor: 'rgba(255,255,255,0.05)', borderRadius: 2 }}
                        />
                        {/* Message Field */}
                        <TextField
                            id="message"
                            name="message"
                            label="Message"
                            variant="outlined"
                            fullWidth
                            required
                            multiline
                            minRows={5}
                            value={formData.message}
                            onChange={handleInputChange}
                            placeholder="Your message"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <ChatBubbleIcon sx={{ color: '#64ffda', fontSize: 28 }} />
                                    </InputAdornment>
                                ),
                                sx: { fontSize: '1.2rem' }
                            }}
                            inputProps={{ style: { fontSize: '1.2rem' } }}
                            sx={{ bgcolor: 'rgba(255,255,255,0.05)', borderRadius: 2 }}
                        />
                        <Button
                            type="submit"
                            className="submit-btn"
                            disabled={isSubmitting}
                            variant="contained"
                            sx={{ width: '100%', py: 1.5, fontWeight: 600, fontSize: '1.1rem', borderRadius: 2, background: 'linear-gradient(135deg, #64ffda, #00d4ff)', color: '#0a0a0a', boxShadow: 2, '&:hover': { background: 'linear-gradient(135deg, #00d4ff, #64ffda)' } }}
                            startIcon={<SendIcon />}
                        >
                            {isSubmitting ? "Sending..." : "Send Message"}
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

export default Contact;
